import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../api/analytics';

export default function PageViewTracker() {
  const { pathname } = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    // The ref survives StrictMode's effect replay, but resets on a fresh page load.
    if (lastPath.current === pathname) return;
    lastPath.current = pathname;
    void trackPageView(pathname);
  }, [pathname]);

  return null;
}
